// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
import httpPlugin from './plugins/http';
import mixins from './util/mixins';
import vmodal from 'vue-js-modal';

import VeeValidate, {
  Validator
} from 'vee-validate';
import ptBR from 'vee-validate/dist/locale/pt_BR';
Validator.localize('pt_BR', ptBR);
Vue.use(VeeValidate);

Vue.use(httpPlugin, {
  store,
  router
});

Vue.mixin(mixins);

Vue.use(vmodal);

const moment = require('moment')
require('moment/locale/pt-br')

Vue.use(require('vue-moment'), {
  moment
})

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js